import {createApp} from '../../../../../vendor/vue/dist/vue.esm-browser.js';
import {get} from "./data-manager";
import Animate from "./animate";

export default class SearchAll {
    constructor($el) {
        this.$wrapper = $el;

        this.createVueApp = this.createVueApp.bind(this);
        this.createVueApp();
    }

    createVueApp() {
        const container = this.$wrapper;
        const app = createApp({
            data() {
                return {
                    searchText: '',
                    categories: {},
                    products: {},
                    totalCategories: 0,
                    totalProducts: 0,
                    searching: false,
                    timer: null,
                    page: 1,
                    pagination: null,
                }
            },
            methods: {
                highlightSearch(search) {
                    var exp = `(${this.searchText})`
                    var reg = new RegExp(exp, "gi")
                    return search.replaceAll(reg, "<strong>$1</strong>");
                },
                async search() {
                    let params = this.getFilters();
                    this.setFiltersInUrl(params);

                    clearTimeout(this.timer);

                    this.timer = setTimeout(async () => {
                        if (!this.searchText) {
                            this.categories = {};
                            this.products = {};
                            this.pagination = null;
                            return;
                        }

                        this.searching = true;

                        const url = `${baseHref}ajax/search`;
                        if (this.abortController) {
                            this.abortController.abort();
                        }

                        this.abortController = new AbortController();

                        const result = await get(url, {
                            'q': this.searchText,
                            'page': this.page
                        }, this.abortController.signal);

                        if (result && Array.isArray(result.tabs)) {
                            const categoryResults = result.tabs.find(tab => tab.slug === 'categorie') || {data: [], count: 0};
                            const productResults = result.tabs.find(tab => tab.slug === 'product') || {data: [], count: 0};

                            this.categories = categoryResults.data;
                            this.products = productResults.data;
                            this.totalCategories = categoryResults.count;
                            this.totalProducts = productResults.count;
                            this.pagination = result.pagination;

                            this.searching = false;
                        }
                    }, 500);
                },
                /**
                 * Get Filters
                 * We get the filters by serializing the form and stripping the empty filters
                 * @returns {{[p: string]: any}}
                 */
                getFilters() {
                    const formData = (new FormData(this.$refs.filters));
                    let filters = Object.fromEntries(formData);

                    // now we remove the empty filters
                    filters = Object.fromEntries(
                        Object.entries(filters).filter(
                            ([filter, value]) => {
                                if (value) {
                                    return [filter, value];
                                }
                            }
                        )
                    );

                    return filters;
                },
                /**
                 * Set the current filters in the url
                 * @param filters
                 */
                setFiltersInUrl(filters) {
                    var params = structuredClone(filters);
                    delete params.search;

                    const url = new URL(window.location.href);
                    url.search = (new URLSearchParams(params)).toString();

                    window.history.pushState({}, "", url.toString())
                },
                /**
                 * Set filters by the active url
                 */
                getFiltersByUrl() {
                    const params = (new URLSearchParams(window.location.search));

                    if (params.has('page')) {
                        this.page = parseInt(params.get('page'));
                    }

                    if (params.has('q')) {
                        this.searchText = params.get('q');
                    }
                },
                setPage(page) {
                    this.page = page;
                    setTimeout(function () {
                        window.scrollTo(0, 0);
                    }, 2);
                    this.$nextTick(this.search);
                },
                clearSearch() {
                    this.categories = {};
                    this.products = {};
                    this.searchText = '';
                    this.pagination = null;
                }
            },
            async mounted() {
                document.body.addEventListener('click', (e) => {
                    if (!document.querySelector('.search--full')) {
                        this.categories = {};
                        this.products = {};
                    }
                });

                await this.search();

                container.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
            },
            created() {
                if (window.location.search) {
                    this.getFiltersByUrl();
                }
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$wrapper);
    }
}
